import React, { useState, useEffect, useContext, useRef } from 'react';
import { ThemeContext } from "../../Layout/Theme/ThemeContext";
import { useNavigate, useLocation, Link } from 'react-router-dom';
import AssetService from "../Controller/AssetController";
import AssetDetailModal from "./AssetDetail";
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import Common from '../../Common/Common';
import HelpSite from "../../Common/HelpLink";
import ModuleService from "../../Setup/controller/ModuleController/ModuleController";
import { useTranslation } from 'react-i18next';
import ColumnOptionDropDown from "../../Lead/Views/LeadForms/ColumnOptionDropDown";
import Cookies from "js-cookie";
import { formatDateWithFns } from '../../Common/DateInputFormat';
import useDateFormat from '../../Common/fetchDateFormat';
import LockReleaseService from "../../Setup/controller/LockReleaseController/LockModuleController";
import CustomerService from "../../Customer/Controller/CustomerController";
import MultiSearchDropDown from "../../Common/MultiSearchDropDown";
import JasperReportService from '../../Dashboard/Controller/JasperReportController';
import axiosInstance from '../../../config/axiosInstance';
import Draggable from 'react-draggable';

import ReportService from "../../Setup/controller/ReportController/ReportController";
import TermsConditionService from "../../Setup/controller/TermsConditionController/TermsConditionController";
import BASE_URL from "../../../config/config";
import { PDFDocument } from "pdf-lib";
import ImportTableService from "../../Setup/controller/ImportTables/ImportTable";
import CompanySetupController from "../../SuperAdmin/Controller/Client/SACompanyListController";
function AssetList({ ClientCompanyID }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const tableRef = useRef();
  const { theme, toggleTheme } = useContext(ThemeContext);
  let accordTheme = "accordion-header-light";
  if (theme === "dark") {
    accordTheme = "accordion-header-dark";
  }
  const [assetList, setAssetData] = useState([]);
  const [modalInstanceAssetDetail, setModalInstanceAssetDetail] = useState(null);
  const [showAssetDetailModal, setShowAssetDetailModal] = useState(false); // State to control AssetDetailModal visibility
  const [loading, setLoading] = useState(true);
  const [selectedId, setSelectedId] = useState("0");
  const redirectCallback = () => {
    navigate('/'); // Redirect to the login page
  };
  const [currentPage, setCurrentPage] = useState(1); // Current page
  const [totalPages, setTotalPages] = useState(1); // Total number of pages
  const [searchQuery, setSearchQuery] = useState('');
  const [poCount, setPOCount] = useState(0);
  const [multipleIds, setMultipleIds] = useState([]);
  const UserID = localStorage.getItem("UserID");
  const CompanyID = localStorage.getItem("CompanyID");
  const activeDateFormat = useDateFormat();
  const [recentSearches, setRecentSearches] = useState([]);
  const setSortConfigInCookie = (config) => {
    Cookies.set(`AssetSort_${CompanyID}_${UserID}`, JSON.stringify(config), { expires: 365 });
  };
  const getSortConfigFromCookie = () => {
    const sortCookie = Cookies.get(`AssetSort_${CompanyID}_${UserID}`);
    return sortCookie ? JSON.parse(sortCookie) : { key: 'ID', direction: 'desc' };
  };
  const [sortConfig, setSortConfig] = useState(getSortConfigFromCookie());

  const setPageSizeInCookie = (pageSize) => {
    document.cookie = `pageSize=${pageSize};path=/;max-age=31536000`; // 1 year
  };
  const getPageSizeFromCookie = () => {
    const match = document.cookie.match(new RegExp('(^| )pageSize=([^;]+)'));
    return match ? parseInt(match[2], 10) : 10; // Default to 10 if no cookie is found
  };
  const [pageSize, setPageSize] = useState(getPageSizeFromCookie());
  const [isModalOpen, setIsModalOpen] = useState(false);
  async function fetchSearchLog() {
    try {

      const searchList = await CustomerService.GetSearchLog("3");
      setRecentSearches(searchList);
    } catch (error) {
      console.error('Error fetching Roles:', error);
    }
  }
  useEffect(() => {
    fetchAsset(currentPage, pageSize);
    fetchSearchLog();
  }, [currentPage, pageSize]);
  useEffect(() => {
    fetchAsset(currentPage, pageSize);
  }, [sortConfig]);

  const UserLockRelease = async () => {
    try {
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };
      const CompanyID = localStorage.getItem("CompanyID");
      if (CompanyID === null || CompanyID === "null") {
        redirectCallback();
      }
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "2");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "3");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "4");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "5");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "6");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "7");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "8");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "9");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "10");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "15");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "17");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "18");

    } catch (error) {
      console.error('Error fetching Teams:', error);
    }
  };
  const fetchAsset = async (page, size) => {
    try {

      setLoading(true);
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };
      localStorage.setItem('AssetID', "");


      const Start = Math.round((parseInt(page) * parseInt(size)) - (size - 1)).toString();
      const PageSize = size.toString();

      const assetData = await AssetService.AllNewAssets(redirectCallback, ClientCompanyID, Start.toString(), PageSize.toString(),
        searchQuery.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns.toString());
      setAssetData(assetData);

      const assetCount = await AssetService.GetAssetCount(redirectCallback, ClientCompanyID, searchQuery, searchColumns.toString());
      setPOCount(assetCount[0].TotalRecords);
      setTotalPages(Math.ceil(assetCount[0].TotalRecords / size));

    } catch (error) {
      console.error('Error fetching Teams:', error);
    }
    finally {
      setLoading(false); // Stop loading after fetching
    }
  };
  useEffect(() => {
    IsModuleAssigned();
    UserLockRelease();
    fetchAsset("0", pageSize);
  }, [ClientCompanyID]);

  const handleCreateAssetClick = () => {
    localStorage.setItem('AssetID', "");
    localStorage.setItem('AssetID', "0");
    localStorage.setItem('HasRecordUpdated', "0");
    setSelectedId("0");
    setIsModalOpen(true);
  };

  const handleCloseModal = async (isChanged) => {


    const closeModal = async () => {
      await AssetService.UnLockAsset(localStorage.getItem('AssetID'));
      if (localStorage.getItem('HasRecordUpdated') == "1") {

        fetchAsset("0", pageSize);
      }
      setMultipleIds([]);
      setIsModalOpen(false);
    };

    if (isChanged != true) {
      closeModal();
      return;
    }

    Swal.fire({
      title: 'Are you sure?',
      text: `Are you sure you want to close this record?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, close it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        closeModal();
      }
    });

  };
  const fetchAssetDetail = async (AssetID) => {
    try {

      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };
      if (AssetID > 0) {
        const AssetDetail = await AssetService.GetAssetByID(redirectCallback, AssetID);
        return AssetDetail;
      }
    } catch (error) {
      console.error('Error fetching asset details:', error);
    }
  };
  const handleEditClick = async (AssetID) => {
    const IsAlreadyLeadID = localStorage.getItem('AssetID');
    if (IsAlreadyLeadID) {
      await AssetService.UnLockAsset(IsAlreadyLeadID);
    }
    const AssetDetail = await fetchAssetDetail(AssetID);
    if (AssetDetail.length > 0) {
      localStorage.setItem('AssetID', "");
      localStorage.setItem('AssetID', AssetID);
      localStorage.setItem('HasRecordUpdated', "0");
      setSelectedId(AssetID);
      setIsModalOpen(true);

    }
  };

  const handleDeleteClick = async (event) => {
    event.stopPropagation(); // Prevent the row click event
    if (multipleIds.length > 0) {
      Swal.fire({
        title: 'Are you sure?',
        text: `You are about to delete ${multipleIds.length} record(s). This cannot be undone!`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: t('confirmDelete')
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await AssetService.DeleteAsset(multipleIds);
            setMultipleIds([]);
            await fetchAsset("0", pageSize);
            setSelectedId("0");
            Swal.fire(
              t('deleteSuccess'),
              t('deleteSuccessMessage'),
              'success'
            );
          } catch (error) {
            console.error('Error deleting job:', error);
            Swal.fire(
              'Error!',
              'There was a problem deleting the record.',
              'error'
            );
          }
        }
      });
    }
    else {
      Swal.fire(
        t('error'),
        t('checkOneRecord'),
        'warning'
      );
    }
  };
  const handleCheckboxChange = (event, id) => {
    event.stopPropagation();
    setSelectedId((prevSelectedId) => (prevSelectedId === id ? "0" : id)); // Toggle selection
    setMultipleIds((prevSelectedIds) => {
      if (event.target.checked) {
        return [...prevSelectedIds, id];
      } else {
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      }
    });
  };
  const redirecttoUnAuthorzied = () => {
    navigate('/Unauthorized'); // Redirect to the login page
  };

  const IsModuleAssigned = async () => {
    try {
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };
      const CompanyID = localStorage.getItem("CompanyID");
      if (CompanyID === null || CompanyID === "null") {
        redirectCallback();
      }
      const Modules = await ModuleService.GetModuleByClientID(CompanyID, "3");
      if (Modules.length === 0) {
        Swal.fire(
          'UnAuthorzied Access!',
          'Sorry, You are not authorized to access this module.',
          'warning'
        );
        redirecttoUnAuthorzied();
      }
    } catch (error) {
      console.error('Error fetching Teams:', error);
    }
  };

  const handlePageChange = (page) => {
    setAssetData([]);
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);

    }
  };
  const handlePageSizeChange = (event) => {
    const newPageSize = parseInt(event.target.value, 10);
    setPageSize(newPageSize);
    setPageSizeInCookie(newPageSize);
    setCurrentPage(1); // Reset to the first page
  };
  const handleSearchButtonClick = async () => {
    setCurrentPage(1); // Reset to first page
    setAssetData([]); // Clear previous data
    const query = searchQuery.toLowerCase(); // Use current searchQuery state
    let columnsToSearch = searchColumns.length > 0
      ? searchColumns.join(",")
      : "ALL";
    setSearchOptions(columnsToSearch);
    const leadData = await AssetService.AllNewAssets(redirectCallback, ClientCompanyID, currentPage, pageSize.toString(),
      query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), columnsToSearch.toString());
    setAssetData(leadData);

    const leadCount = await AssetService.GetAssetCount(redirectCallback, ClientCompanyID, searchQuery, columnsToSearch.toString());
    setPOCount(leadCount[0].TotalRecords);
    setTotalPages(Math.ceil(leadCount[0].TotalRecords / pageSize)); // Set total pages dynamically

    const searchList = await CustomerService.GetSearchLog("3");
    setRecentSearches(searchList);
  };
  const handleSort = async (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }

    const newConfig = { key, direction };
    setSortConfig(newConfig);
    setSortConfigInCookie(newConfig);
    setCurrentPage(1);

    setSortConfig({ key, direction });
    const porderData = await AssetService.AllNewAssets(redirectCallback, ClientCompanyID, "1", pageSize.toString(),
      searchQuery.toString(), key.toString(), direction.toString(), searchColumns.toString());

    const porderCount = await AssetService.GetAssetCount(redirectCallback, ClientCompanyID, searchQuery, searchColumns.toString());

    setPOCount(porderCount[0].TotalRecords);
    setAssetData(porderData);

    setTotalPages(Math.ceil(porderCount[0].TotalRecords / pageSize));
  };
  const defaultColumns = [
    "vc_AssetCode",
    "vc_AssetName",
    "Avc_Description",
    "ACompanyName",
    "ABranchName",
    "writeOff",
    "Aprice",
    "ModifiedBy",
    "writeOff",
  ];

  const columnOptions = [
    { value: "vc_AssetCode", label: "Asset Code" },
    { value: "vc_AssetName", label: "Asset Name" },
    { value: "Avc_Description", label: "Description" },
    { value: "ACompanyName", label: "Customer" },
    { value: "ABranchName", label: "Site" },
    { value: "Aprice", label: "	Price" },
    { value: "writeOff", label: "	Write Off" },
    { value: "UpdatedDate", label: "Updated Date" },
    { value: "ModifiedBy", label: "ModifiedBy" },


  ];

  const getStoredColumns = () => {
    const storedColumns = Cookies.get(`AssetsColumns_${CompanyID}`);
    return storedColumns ? JSON.parse(storedColumns) : columnOptions.map(option => option.value);
  };

  const [visibleColumns, setVisibleColumns] = useState(getStoredColumns());

  const handleColumnChange = (selectedOptions) => {
    setVisibleColumns(selectedOptions);

    // Save selection to cookies (valid for 1 year)
    Cookies.set(`AssetsColumns_${CompanyID}`, JSON.stringify(selectedOptions), { expires: 365 });
  };

  const defaultColumnsForSearch = [
    "vc_AssetCode",
    "vc_AssetName",
    "Avc_Description",
    "ACompanyName",
    "ABranchName",
    "writeOff",
    "Aprice",
    "ModifiedBy"
  ];
  const [searchColumns, setSearchColumns] = useState(defaultColumnsForSearch);
  const [searchOptions, setSearchOptions] = useState(defaultColumnsForSearch);
  const columnSearchOptions = [
    { value: "vc_AssetCode", label: "Asset Code" },
    { value: "vc_AssetName", label: "Asset Name" },
    { value: "Avc_Description", label: "Description" },
    { value: "ACompanyName", label: "Customer" },
    { value: "ABranchName", label: "Site" },
    { value: "Aprice", label: "	Price" },
    { value: "writeOff", label: "	Write Off" },
    { value: "UpdatedDate", label: "Updated Date" },
    { value: "ModifiedBy", label: "ModifiedBy" }

  ];
  const handleSearchColumnChange = (selectedOptions) => {
    setSearchColumns(selectedOptions);

  };
  const handleExportExcel = async () => {

    if (multipleIds.length === 0) {
      Swal.fire(
        'Warning!',
        'Please select at least one record to export.',
        'warning'
      );
      return;
    }
    setLoading(true);

    try {

      const selectedAssets = assetList.filter(asset =>
        multipleIds.includes(asset.PK_Assets_ID)
      );


      if (!selectedAssets || selectedAssets.length === 0) {
        Swal.fire(
          'Warning!',
          'No data to export.',
          'warning'
        );
        return;
      }

      const fieldsData = await ImportTableService.GetAllImportFields(redirectCallback, "4");

      const fields = fieldsData.filter(
        field => field && (field.vc_FieldName || field.vc_DisplayName)
      );

      if (!fields || fields.length === 0) {
        Swal.fire(
          'Warning!',
          'No field definitions found for export.',
          'warning'
        );
        return;
      }
      const headers = fields.map(field => field.vc_DisplayName || field.vc_FieldName || field);
      const validSelectedAssets = selectedAssets.filter(
        asset => asset && Object.keys(asset).length > 0
      );

      const rows = validSelectedAssets.map(row =>
        fields.map(field => {
          const col = field.vc_FieldName || field;
          let value = row[col];

          if (col === "Avc_Description") value = row.vc_Description ?? "";
          if (col === "ACompanyName") value = row.CompanyName ?? "";
          if (col === "ABranchName") value = row.BranchName ?? "";
          if (col === "FK_AssetSubCategory_ID") value = row.SubCategoryName ?? "";
          if (col === "snt_AssetCat") value = row.AssetCategory ?? "";

          return `"${String(value ?? '').replace(/"/g, '""')}"`;
        }).join(',')
      );
      const csvContent = [
        headers.join(','), // CSV Header
        ...rows            // CSV Rows
      ].join('\n');

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Assets.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    } catch (error) {
      console.error('Error exporting selected assets:', error);
    } finally {
      setLoading(false);
    }
  };
  const [lastCheckedIndex, setLastCheckedIndex] = useState(null);

  // NEW: handle click (not change)
  const handleCheckboxClick = (event, id, index) => {
    event.stopPropagation();

    const isChecked = event.target.checked;

    if (event.shiftKey && lastCheckedIndex !== null) {
      const start = Math.min(lastCheckedIndex, index);
      const end = Math.max(lastCheckedIndex, index);
      const idsInRange = assetList.slice(start, end + 1).map(l => l.PK_Assets_ID);

      setMultipleIds(prev => {
        const s = new Set(prev);
        if (isChecked) {
          idsInRange.forEach(x => s.add(x));     // range select
        } else {
          idsInRange.forEach(x => s.delete(x));  // range unselect
        }
        return Array.from(s);
      });
    } else {
      // normal single toggle
      setMultipleIds(prev => {
        const s = new Set(prev);
        if (isChecked) s.add(id); else s.delete(id);
        return Array.from(s);
      });
    }

    // Always update the anchor index
    setLastCheckedIndex(index);
  };

  const getInitialWidths = () => {
    const saved = Cookies.get(`AssetColumnWidths_${CompanyID}_${UserID}`);
    const defaults = {};

    visibleColumns.forEach(col => {
      defaults[col] = 110;
    });

    if (!saved) return defaults;

    const parsed = JSON.parse(saved);
    const applied = {};

    visibleColumns.forEach(col => {
      applied[col] = parsed[col] || 110;
    });

    return applied;
  };

  const [columnWidths, setColumnWidths] = useState(getInitialWidths);
  const startX = useRef(0);
  const startWidth = useRef(0);
  const resizingColumn = useRef(null);
  const MIN_COL_WIDTH = 60;

  /**
   * Load widths from cookie when visibleColumns changes
   */
  useEffect(() => {
    const savedWidths = Cookies.get(`AssetColumnWidths_${CompanyID}_${UserID}`);
    if (savedWidths) {
      const parsed = JSON.parse(savedWidths);
      setColumnWidths((prev) => ({
        ...prev,
        ...parsed
      }));
    }
  }, [assetList]);


  /**
   * Start Column Resize
   */
  const startResize = (e, key) => {
    e.stopPropagation();
    startX.current = e.clientX;
    resizingColumn.current = key;

    const th = e.target.closest("th");   // FIXED HERE
    startWidth.current = th.offsetWidth;

    document.addEventListener("mousemove", resizeColumn);
    document.addEventListener("mouseup", stopResize);
  };

  /**
   * Resize Column dynamically
   */
  const resizeColumn = (e) => {
    if (!resizingColumn.current) return;

    const delta = e.clientX - startX.current;
    const newWidth = Math.max(startWidth.current + delta, MIN_COL_WIDTH);

    setColumnWidths(prev => ({
      ...prev,
      [resizingColumn.current]: newWidth
    }));
  };
  useEffect(() => {
    setColumnWidths(getInitialWidths());
  }, [visibleColumns]);

  /**
   * Stop resizing and save to cookie
   */
  const stopResize = () => {
    document.removeEventListener("mousemove", resizeColumn);
    document.removeEventListener("mouseup", stopResize);

    const key = resizingColumn.current;
    if (key) {
      setColumnWidths(prev => {
        // Save using the most recent updated state
        Cookies.set(
          `AssetColumnWidths_${CompanyID}_${UserID}`,
          JSON.stringify(prev),
          { expires: 365 }
        );
        return prev;
      });
    }

    resizingColumn.current = null;
  };


  /**
   * Auto-fit column width
   */
  const autoFitColumn = (key) => {
    const cells = document.querySelectorAll(`[data-col='${key}']`);
    let maxWidth = 0;

    cells.forEach(cell => {
      maxWidth = Math.max(maxWidth, cell.scrollWidth);
    });

    const newWidth = maxWidth + 20;

    const updated = { ...columnWidths, [key]: newWidth };

    setColumnWidths(updated);

    Cookies.set(
      `AssetColumnWidths_${CompanyID}_${UserID}`,
      JSON.stringify(updated),
      { expires: 365 }
    );
  };

  const [showPdfModal, setShowPdfModal] = useState(false);
  const [imageData, setImageData] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [reportTitle, setReportTitle] = useState('');
  const [reportLink, setReportLink] = useState('');
  const [inputValues, setInputValues] = useState({});
  const [outputData, setOutputData] = useState([]);
  const [error, setError] = useState(null);
  const getMergedPDFBytes = async (id) => {
    try {
      const currentInputValues = {
        ClientID: localStorage.getItem("CompanyID"),
        ID: id
      };

      const redirectCallback = () => navigate('/');

      let reportData = await ReportService.GetCompanyReports(redirectCallback, "3");
      reportData = reportData.filter(x => x.IsDefault.toString() === "1");

      const reportID = reportData.length > 0 ? reportData[0].ID : 115;
      const JasperReport = await JasperReportService.GetJasperReportByID(reportID);

      const queryObjMain = {
        ...currentInputValues,
        format: 'pdf',
        ReportName: JasperReport[0].ReportName,
        ReportType: JasperReport[0].ReportType,
        name: JasperReport[0].ReportName
      };

      const responseMain = await axiosInstance.get(
        `/Dashboard/ProxyReport?${new URLSearchParams(queryObjMain)}`,
        { responseType: 'blob' }
      );

      const mainPdfBytes = await responseMain.data.arrayBuffer();

      const pdfDoc = await PDFDocument.load(mainPdfBytes);

      return pdfDoc;

    } catch (err) {
      console.error(err);
      return null;
    }
  };
  const handlePrintUser = async (event) => {
    event.stopPropagation();


    setLoading(true);
    const includeTerms = false;

    if (multipleIds.length > 0) {
      try {
        const finalMergedPdf = await PDFDocument.create();

        // ================= MERGE INVOICES =================
        for (const id of multipleIds) {

          const pdfDoc = await getMergedPDFBytes(id);

          if (!pdfDoc) continue;

          const pages = await finalMergedPdf.copyPages(
            pdfDoc,
            pdfDoc.getPageIndices()
          );

          pages.forEach(page => finalMergedPdf.addPage(page));
        }

        const finalBytes = await finalMergedPdf.save();
        const finalBlob = new Blob([finalBytes], { type: "application/pdf" });

        const finalUrl = URL.createObjectURL(finalBlob);
        setLoading(false);
        setPdfUrl(finalUrl);
        setShowPdfModal(true);

      } catch (err) {
        console.error('Error executing report:', err);
        setError('Failed to execute the report.');
      }
    } else {
      Swal.fire(
        'Error!',
        'Please check at least one record to print job.',
        'warning'
      );
    }
  };

  const handleStart = (e, ui) => {
    e.stopPropagation();
  }
  const handleWriteOff = async (event) => {
    event.stopPropagation(); // Prevent the row click event
    if (multipleIds.length > 0) {
      Swal.fire({
        title: 'Are you sure?',
        text: `You are about to write off ${multipleIds.length} record(s).`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: t('confirmDelete')
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await AssetService.WriteOff(multipleIds);
            setMultipleIds([]);
            await fetchAsset("0", pageSize);
            setSelectedId("0");
            Swal.fire(
              "Success",
              "The selected record(s) write off successfully",
              'success'
            );
          } catch (error) {
            console.error('Error deleting job:', error);
            Swal.fire(
              'Error!',
              'There was a problem deleting the record.',
              'error'
            );
          }
        }
      });
    }
    else {
      Swal.fire(
        t('error'),
        t('checkOneRecord'),
        'warning'
      );
    }
  }
  const handleReinstate = async (event) => {
    event.stopPropagation(); // Prevent the row click event
    if (multipleIds.length > 0) {
      Swal.fire({
        title: 'Are you sure?',
        text: `You are about to Reinstate ${multipleIds.length} record(s).`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: t('confirmDelete')
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await AssetService.DisabledWriteOff(multipleIds);
            setMultipleIds([]);

            await fetchAsset("0", pageSize);
            setSelectedId("0");
            Swal.fire(
              "Success",
              "The selected record(s) Reinstate successfully",
              'success'
            );
          } catch (error) {
            console.error('Error Reinstate job:', error);
            Swal.fire(
              'Error!',
              'There was a problem Reinstate the record.',
              'error'
            );
          }
        }
      });
    }
    else {
      Swal.fire(
        t('error'),
        t('checkOneRecord'),
        'warning'
      );
    }
  }
  return (
    <div>
      {ClientCompanyID === 0 && (
        <Common showAddButton={'yes'} handleAddTask={handleCreateAssetClick}
          showDeleteButton={'yes'} handleDeleteItem={handleDeleteClick} ModuleID={"3"}
          showExportButton={'yes'} handleExportExcel={handleExportExcel}
          showPrintUser={'yes'} handlePrintUser={handlePrintUser}
          showWriteOffButton={'yes'} handleWriteOff={handleWriteOff}
          showReinstateButton={'yes'} handleReinstate={handleReinstate}

          HelpFormName="Asset List" HelpModule="4"
          RecordID={multipleIds}
        />
      )}
      {loading && (
        <div class="loading">
          <div class="d-table">
            <div class="d-tablecell">
              <span class="loader">
                <span class="loader-inner"></span>
              </span>
            </div>
          </div>
        </div>
      )}
      <div className="main-content-header">
        <div className="row mb-3" style={{ marginLeft: "-5px" }}>
          {(ClientCompanyID === 0 &&
            <div className="col-xl-2">
              <h1>{t('assetList')}</h1>
            </div>
          )}
          {(ClientCompanyID > 0 &&
            <div className="col-xl-2">
              <button className='btn btn-primary btn-sm' onClick={handleCreateAssetClick}>
                <i className="icofont-plus" aria-hidden="true"> {t('addNew')}</i>
              </button>
            </div>
          )}

          <div className="col-xl-10 d-flex justify-content-end">
            <ColumnOptionDropDown
              options={columnOptions}
              selectedOptions={visibleColumns}
              onChange={handleColumnChange}
            />


          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12">
          <div className="card mb-30">
            <div className="card-body">

              <div className="">
                <div className="row mb-3">
                  <div className="col-sm-1">
                    <select id="pageSize" className="form-control" value={pageSize} onChange={handlePageSizeChange}>
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                      <option value={500}>500</option>
                      <option value={1000}>1000</option>
                    </select>
                  </div>
                  <label style={{ paddingLeft: "0px" }} className="col-sm-2" htmlFor="pageSize">entries per page: </label>
                  <div className="col-sm-6"></div>
                  <div className="col-sm-1 d-flex align-items-center justify-content-end">
                    <span className="me-2">Search</span>

                    <MultiSearchDropDown
                      options={columnSearchOptions}
                      selectedOptions={searchColumns}
                      onChange={handleSearchColumnChange}
                    />
                  </div>

                  <div className="col-sm-2 d-flex justify-content-end">
                    <input
                      list="recent-searches"
                      type="text"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      className="form-control me-2"
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          handleSearchButtonClick();
                        }
                      }}
                    />
                    <datalist id="recent-searches">
                      {recentSearches.map((item, idx) => (
                        <option key={idx} value={item.SearchQuery} />
                      ))}
                    </datalist>
                    <button onClick={() => handleSearchButtonClick()} style={{ background: "none", border: "none" }}>
                      <img src="assets/img/resources/search.png" class="top-icon" alt="Add icon" />
                    </button>
                  </div>
                </div>
                <div style={{ maxHeight: "80vh", overflow: "auto" }}>
                  <table
                    style={{
                      tableLayout: "fixed",
                      width: "max-content",
                      minWidth: "100%"
                    }}
                    className="table m-0 table-hover"
                    ref={tableRef}
                  >
                    <thead classname="table-light" style={{ position: "sticky", top: 0, zindex: 2 }}>
                      <tr>
                        <th
                          className="checkbox-header"
                          style={{
                            width: "40px",
                            minWidth: "40px",
                            maxWidth: "40px",
                            position: "sticky",
                            left: 0,
                            zIndex: 5,

                          }}
                        ></th>
                        {visibleColumns.includes("vc_AssetCode") &&
                          <th onClick={() => handleSort('vc_AssetCode')}

                            style={{
                              width: `${columnWidths?.vc_AssetCode}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('assetCode')}<i
                              className={`ms-1 icofont ${sortConfig.key === 'vc_AssetCode'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "vc_AssetCode");
                              }}
                              onDoubleClick={() => autoFitColumn("vc_AssetCode")}
                            /></th>
                        }
                        {visibleColumns.includes("vc_AssetName") &&
                          <th onClick={() => handleSort('vc_AssetName')}

                            style={{
                              width: `${columnWidths?.vc_AssetName}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('assetName')}<i
                              className={`ms-1 icofont ${sortConfig.key === 'vc_AssetName'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "vc_AssetName");
                              }}
                              onDoubleClick={() => autoFitColumn("vc_AssetName")}
                            /></th>
                        }
                        {visibleColumns.includes("Avc_Description") &&
                          <th onClick={() => handleSort('vc_Description')}

                            style={{
                              width: `${columnWidths?.vc_Description}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('description')}<i
                              className={`ms-1 icofont ${sortConfig.key === 'vc_Description'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "vc_Description");
                              }}
                              onDoubleClick={() => autoFitColumn("vc_Description")}
                            /></th>
                        }
                        {visibleColumns.includes("ACompanyName") &&
                          <th onClick={() => handleSort('CompanyName')}

                            style={{
                              width: `${columnWidths?.CompanyName}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('customer')}<i
                              className={`ms-1 icofont ${sortConfig.key === 'CompanyName'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "CompanyName");
                              }}
                              onDoubleClick={() => autoFitColumn("CompanyName")}
                            /></th>
                        }
                        {visibleColumns.includes("ABranchName") &&
                          <th onClick={() => handleSort('BranchName')}

                            style={{
                              width: `${columnWidths?.BranchName}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('site')}<i
                              className={`ms-1 icofont ${sortConfig.key === 'BranchName'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "BranchName");
                              }}
                              onDoubleClick={() => autoFitColumn("BranchName")}
                            /></th>
                        }
                        {visibleColumns.includes("writeOff") &&
                          <th

                            style={{
                              width: `${columnWidths?.writeOff}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('writeOff')}</th>
                        }
                        {visibleColumns.includes("Aprice") &&
                          <th

                            style={{
                              width: `${columnWidths?.Aprice}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('price')}</th>
                        }
                        {visibleColumns.includes("ModifiedBy") &&
                          <th onClick={() => handleSort('ModifiedBy')}
                            style={{
                              width: `${columnWidths?.ModifiedBy}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Modified By
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'ModifiedBy'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i>
                            <div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "ModifiedBy");
                              }}
                              onDoubleClick={() => autoFitColumn("ModifiedBy")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("UpdatedDate") &&
                          <th onClick={() => handleSort('UpdatedDate')}

                            style={{
                              width: `${columnWidths?.UpdatedDate}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Last Action
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'UpdatedDate'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ><div
                                className="resize-handle"
                                onMouseDown={(e) => {
                                  e.stopPropagation();   // STOP the click event from bubbling
                                  startResize(e, "UpdatedDate");
                                }}
                                onDoubleClick={() => autoFitColumn("UpdatedDate")}
                              /></i>
                          </th>
                        }

                      </tr>
                    </thead>
                    <tbody>
                      {assetList.map((asset, index) => (
                        <tr key={asset.PK_Assets_ID}
                          onClick={() => handleEditClick(asset.PK_Assets_ID)}
                          style={{
                            backgroundColor: selectedId.toString() === asset.PK_Assets_ID.toString() ? 'rgb(197, 218, 237)' : '', // Highlight background
                            cursor: 'pointer',
                          }}>
                          <td
                            className="checkbox-cell"
                            onClick={(e) => e.stopPropagation()}
                            style={{
                              width: "40px",
                              minWidth: "40px",
                              maxWidth: "40px",
                              position: "sticky",
                              left: 0,
                              zIndex: 3,
                              backgroundColor:
                                selectedId.toString() === asset.PK_Assets_ID.toString()
                                  ? 'rgb(197, 218, 237)'
                                  : '#fff'
                            }}
                          >
                            <div
                              className="checkbox-hover-area"
                              onClick={(event) => handleCheckboxClick(event, asset.PK_Assets_ID, index)}
                            >
                              <input
                                type="checkbox"
                                checked={multipleIds.includes(asset.PK_Assets_ID)}
                                readOnly
                              />
                            </div>
                          </td>
                          {visibleColumns.includes("vc_AssetCode") &&
                            <td style={{
                              width: columnWidths.vc_AssetCode,
                              minWidth: MIN_COL_WIDTH,
                            }} className="no-wrap ellipsis" title={asset.vc_AssetCode}>

                              {asset.vc_AssetCode}

                            </td>
                          }
                          {visibleColumns.includes("vc_AssetName") &&
                            <td style={{
                              width: columnWidths.vc_AssetName,
                              minWidth: MIN_COL_WIDTH,
                            }} className="no-wrap ellipsis" title={asset.vc_AssetName}>

                              {asset.vc_AssetName}
                            </td>
                          }
                          {visibleColumns.includes("Avc_Description") &&
                            <td style={{
                              width: columnWidths.vc_Description,
                              minWidth: MIN_COL_WIDTH,
                            }} className="no-wrap ellipsis" title={asset.vc_Description}>

                              {asset.vc_Description}
                            </td>
                          }
                          {visibleColumns.includes("ACompanyName") &&
                            <td style={{
                              width: columnWidths.CompanyName,
                              minWidth: MIN_COL_WIDTH,
                            }} className="no-wrap ellipsis" title={asset.CompanyName}>

                              {asset.CompanyName}
                            </td>
                          }
                          {visibleColumns.includes("ABranchName") &&
                            <td style={{
                              width: columnWidths.BranchName,
                              minWidth: MIN_COL_WIDTH,
                            }} className="no-wrap ellipsis" title={asset.BranchName}>{asset.BranchName}</td>
                          }

                          {visibleColumns.includes("writeOff") && <td>

                            {asset.writeOff === "Yes" && (
                              <img src='assets/img/resources/tick.png' style={{ width: "20px" }}></img>
                            )}
                          </td>}
                          {visibleColumns.includes("Aprice") && <td></td>}



                          {visibleColumns.includes("ModifiedBy") && <td style={{
                            width: columnWidths.ModifiedBy,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">
                            {asset.ModifiedBy ? (
                              <div
                                title={asset.ModifiedBy}
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "25px",
                                  height: "25px",
                                  borderRadius: "50%",
                                  backgroundColor: "#368938",
                                  color: "white",
                                  fontWeight: "bold",
                                  fontSize: "14px",
                                }}
                              >
                                {asset.ModifiedBy.split(" ")
                                  .map(word => word.charAt(0).toUpperCase())
                                  .join("")}
                              </div>
                            ) : (
                              ""
                            )}
                          </td>}
                          {visibleColumns.includes("UpdatedDate") && <td style={{
                            width: columnWidths.UpdatedDate,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">{formatDateWithFns(asset.UpdatedDate, activeDateFormat)}  </td>}


                        </tr>
                      ))}
                    </tbody>
                    <tfoot style={{ position: "sticky", bottom: 0, zIndex: 2, backgroundColor: "white" }}>
                      <tr>
                        <td colSpan={visibleColumns.length + 1}>
                          <div className="pagination-controls" style={{ marginTop: "10px", marginBottom: "10px" }}>
                            Showing {1 + (currentPage * pageSize) - pageSize} to {currentPage * (Math.min(poCount, pageSize))} of {poCount} entries

                            {/* Last Page Button */}
                            <button
                              style={{ float: "right", marginLeft: "5px" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(totalPages)} // Navigate to last page
                              disabled={currentPage === totalPages}
                            >
                              <img src="assets/img/resources/last.png" alt="Add icon" style={{ height: "10px" }} />  Last
                            </button>

                            {/* Next Page Button */}
                            <button
                              style={{ float: "right", marginLeft: "5px" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(currentPage + 1)}
                              disabled={currentPage === totalPages}
                            >
                              <img src="assets/img/resources/next-icon.png" alt="Add icon" style={{ height: "10px" }} /> Next
                            </button>

                            <span style={{ marginLeft: "10px", marginRight: "10px", float: "right" }}>
                              Page {currentPage} of {totalPages}
                            </span>

                            {/* Previous Page Button */}
                            <button
                              style={{ float: "right", marginRight: "5px", marginLeft: "5px" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(currentPage - 1)}
                              disabled={currentPage === 1}
                            >
                              <img src="assets/img/resources/pevious-icon.png" alt="Add icon" style={{ height: "10px" }} /> Prev
                            </button>

                            {/* First Page Button */}
                            <button
                              style={{ float: "right" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(1)} // Navigate to first page
                              disabled={currentPage === 1}
                            >
                              <img src="assets/img/resources/first.png" alt="Add icon" style={{ height: "10px" }} /> First
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tfoot>
                  </table>


                </div>
                {isModalOpen && (
                  <AssetDetailModal AssetID={localStorage.getItem('AssetID')} onClose={handleCloseModal} onSuccess={fetchAsset} ClientCompanyID={ClientCompanyID} />
                )}
                {showPdfModal && pdfUrl && (
                  <div className="modal fade show d-block" tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                      <Draggable handle=".modal-content" onStart={handleStart}>
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title">PDF Report</h5>
                            <button type="button" className="close" onClick={() => setShowPdfModal(false)}>
                              <span>&times;</span>
                            </button>
                          </div>
                          <div className="modal-body">
                            <embed src={pdfUrl} type="application/pdf" width="100%" height="600px" />
                          </div>
                        </div>
                      </Draggable>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AssetList;